import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Elements, CardElement, injectStripe } from 'react-stripe-elements';

import { payShipback, fetchShipback } from '../actions/shipback'
import { setBreadcrumb } from '../actions/breadcrumb'
var pay_stripe;

class _CardForm extends React.Component {

  constructor(props) {
    super()
    this.props = props
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleStripe = this.handleStripe.bind(this)
    this.state = {cards: ["amex", "mastercard", "visa"], card_holder: "", isCreating: false}
  }

  handleInputChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.value;
    this.setState({
      [name]: value
    });
  }

  handleStripe(ev) {
    ev.preventDefault();
    if(this.state.isCreating) return;
    this.setState({isCreating: true});
    this.props.stripe.createPaymentMethod('card', { billing_details: { name : this.state.card_holder }})
      .then(({paymentMethod, error}) => {
        pay_stripe = this.props.stripe;
        this.setState({isCreating: false});
        if(!error) {
          this.props.setPaying();
          this.props.payForReturn(paymentMethod.id);
        }
      });
  }

  renderBankCard(type) {
    return (
      <img key={type} src={bank_cards[type]} alt={type} />
    )
  }

  render() {
    var months = I18n.t('date.month_names')
    return (
      <div className="row mt-5 d-flex checkout">
        <div className="flash alert alert-warning">
          <span dangerouslySetInnerHTML={{__html: I18n.t('shipbacks.checkouts.warning', {amount: Number(this.props.amount / 100).toFixed(2)})}}></span>
        </div>
        <div className="col-lg-6 col-xs-12 offset-lg-1">
          <h2>{I18n.t('shipbacks.checkouts.pay.title')}</h2>
          <div className="row">
            <div className="col-12">
              <label>{I18n.t('activerecord.attributes.customer.card_holder')}</label>
              <input type="text" className="form-control" name="card_holder" value={this.state.card_holder} onChange={this.handleInputChange}></input>
            </div>
            <div className="col-12">
              <label>{I18n.t('activerecord.attributes.customer.card_number')}</label>
              <CardElement className="form-control" />
            </div>
          </div>
        </div>
        <div className="col-lg-5 col-12 mb-5 cards">
          <h2>{I18n.t('shipbacks.checkouts.pay.accepted')}</h2>
          {
            this.state.cards.map((type) => (
              this.renderBankCard(type)
            ))
          }
        </div>
        <div className="col-11">
          <a className="submit pull-right mb-3" onClick={this.handleStripe}>
            {I18n.t('shipbacks.checkouts.pay.pay', {amount: Number(this.props.amount / 100).toFixed(2)})}
          </a>
        </div>
      </div>
    )
  }
}

const CardForm = injectStripe(_CardForm)

class PaidReturn extends React.Component {

  constructor(props) {
    super()
    this.props = this.props
    this.state = {isPaying: false}
    this.payWithToken = this.payWithToken.bind(this)
    this.setPaying = this.setPaying.bind(this)
    this.paySecure = this.paySecure.bind(this)
    this.verifySecure = this.verifySecure.bind(this)
  }

  payWithToken(payment_method_id) {
    this.paySecure(payment_method_id);
  }

  paySecure(payment_method_id) {
    this.props
      .payShipback(payment_method_id, shipback_id, this.props.user_token)
      .then(this.verifySecure)
  }

  verifySecure(result) {
    if (result.requires_action) {
      pay_stripe
        .handleCardAction(result.payment_intent_client_secret)
        .then(this.catchError)
        .then((result) => {
          this.paySecure(null);
        });
    } else if (result.success) {
      this.props.fetchShipback(shipback_id, this.props.user_token);
    } else {
      alert("Please double check your bank details!\nOr contact our team at support@shoprunback.com")
      this.setState({isPaying: false})
    }
  }

  setPaying() {
    this.setState({isPaying: true})
  }

  render() {
    if (this.state.isPaying) {
      return(
        <div className="row spinner">
          <div className="col-12">
            <i className="fa-li fa fa-3x fa-spinner fa-spin"/>
            <h3>{I18n.t('shipbacks.checkouts.pay.processing')}</h3>
          </div>
        </div>
      )
    } else {
      return (
        <div className="checkout">
          <Elements>
            <CardForm amount={this.props.amount} payForReturn={this.payWithToken} setPaying={this.setPaying}/>
          </Elements>
        </div>
      )
    }
  }
}

const mapStateToProps = state => ({
  shipback: state.shipback,
  user_token: state.user,
  customer: state.customer,
})

const mapDispatchToProps = dispatch => bindActionCreators({ payShipback, setBreadcrumb, fetchShipback }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(PaidReturn)


// WEBPACK FOOTER //
// ./app/javascript/components/components/PaidReturn.jsx